<div class="issue-container">
  <button class="accordion" (click)="togglePanelView()" [ngClass]="{ expanded: panelDisplayed }">
    <div class="issue-type-accordion-title gap-8 full-width">
      <div class="issue-header-row">
        @if (!grouped) {
          <div class="issue-type">{{ issue.issue?.title ?? issue.issue.issueTypeDisplayString }}</div>
        }
        @if (grouped) {
          <div class="issue-type">
            {{ resourceTypeString || issue.issue?.title || issue.issue.issueTypeDisplayString }}
          </div>
        }
      </div>
      <div class="resource-id full-width">
        @if (resourceNameString) {
          <div class="resource-name-block">
            @if (!grouped && resourceNameString && resourceTypeString) {
              <span class="resource-type-label">{{ resourceTypeString }}: </span>
            }
            <span class="inline-copy-block">
              <span class="inline-copy-text">{{ resourceNameString }}</span>
            </span>
            @if (resourceNameString) {
              <button
                class="inline-copy-btn"
                [copy-clipboard]="resourceNameString"
                (copied)="onResourceNameCopied()"
                (click)="$event.stopPropagation()"
                aria-label="Copy resource name"
              >
                <i
                  class="fa-utility fa-semibold"
                  [ngClass]="copyFeedback.copiedStates['resource'] ? 'fa-check' : 'fa-copy'"
                ></i>
              </button>
            }
            @if (consoleUrl) {
              <a
                class="console-link-btn"
                href="{{ consoleUrl }}"
                target="_blank"
                rel="noopener"
                (click)="$event.stopPropagation()"
                [pTooltip]="'Open in ' + (application?.type === 'azure' ? 'Azure Portal' : 'AWS Console')"
                tooltipPosition="top"
              >
                <i class="fa-utility fa-semibold fa-arrow-up-right-from-square"></i>
              </a>
            }
          </div>
        } @else {
          <span class="no-resource-text">No associated resource</span>
        }
      </div>
    </div>
    <div id="expand-glyph">
      <i
        class="fa-utility fa-semibold"
        [ngClass]="{ 'fa-angle-down': !panelDisplayed, 'fa-angle-up': panelDisplayed }"
      ></i>
    </div>
  </button>
  <div class="accordion-panel" [@accordionSlide]="panelDisplayed ? 'expanded' : 'collapsed'">
    <issue-body [issue]="issue" [sync-pair]="syncPair" [application]="application"></issue-body>
    <div class="issue-id-container">Issue ID: {{ issue.issueId }}</div>
  </div>
</div>
